import React, { ReactElement } from 'react';
import WishListIconContainer from "../../../components/wishList/wishListIcon/WishListIconContainer";
import circledMenu from '../../../assets/images/circled-menu.png';
import cart from "../../../assets/images/cart.png";

interface Props {
  showLogin?: boolean;
  showLoginMenu: (name: string) => void;
  href?: string;
  isConsumer: boolean;
  alt: string;
  src: string;
  numberOfOrderItems?: number;
}

const MenuIcon: React.FC<Props> = (props: Props): ReactElement => {
  const { showLoginMenu, isConsumer, alt, src } = props;

  interface ISelfProps {
    [key: string]: any;
  }

  const selfProps: ISelfProps = {};

  if (isConsumer) {
    selfProps.onClick = () => {
      showLoginMenu(alt);
    };
  } else {
    selfProps.href = props.href;
  }

  return (
    <>
      <a href={process.env.REACT_APP_CART_OVERVIEW_NEW_URL}>
        <span className="list-item fw-bold">
          <img
            alt="cart"
            className="icon"
            src={cart}
          />
          {Boolean(props.numberOfOrderItems) && (
            <span className="cart-icon-number p-1 px-2">
              {props.numberOfOrderItems}
            </span>
          )}
        </span>
      </a>
      <div className='my-auto me-2'>
        <WishListIconContainer/>
      </div>
      <div className='my-auto mx-2' onClick={() => showLoginMenu("circled-menu")}>
        <img
          alt="circled-menu"
          className="icon mx-auto d-block"
          src={circledMenu}
        />
      </div>
      <div className='my-auto'>
        <a  {...selfProps}>
          <img
            alt={alt}
            className="icon mx-auto d-block"
            src={src}
          />
        </a>
      </div>
    </>

  );
};

export default MenuIcon;
